export default __webpack_public_path__ + "static/media/01.00106fa5.gif";